module.exports = __webpack_public_path__ + "img/stats-national-jockey-header.7b3cbc51.jpg";